import type { FocusJudgment } from "../types";

/** Default `isFocused` probability threshold, shared by both stepGame gating checks
 * (hunt pinch and scare arming) unless a caller overrides it (e.g. StepInput.focusThreshold). */
export const FOCUS_THRESHOLD_DEFAULT = 0.5;

export interface IsFocusedConfig {
  threshold?: number;
  maxAgeMs?: number;
}

/** True when `j` is non-null, not older than `maxAgeMs` (default 5000), and `p >= threshold` (default FOCUS_THRESHOLD_DEFAULT = 0.5). */
export function isFocused(
  j: FocusJudgment | null,
  now: number,
  cfg: IsFocusedConfig = {},
): boolean {
  if (j === null) return false;
  const threshold = cfg.threshold ?? FOCUS_THRESHOLD_DEFAULT;
  const maxAgeMs = cfg.maxAgeMs ?? 5000;
  if (now - j.t > maxAgeMs) return false;
  return j.p >= threshold;
}
